import api from "./api";
import TokenService from "./token.service";

class AuthService {
  login(user) {
    return api
      .post('/dj-rest-auth/login/', {
        email: user.email,
        password: user.password
      })
      .then((response) => {
        if (response.data.access_token) {
          TokenService.setUser(response.data);
        }

        return response.data;
      });
  }

  logout() {
    TokenService.removeUser();
  }

  register(user) {
    return api.post('/dj-rest-auth/registration/', {  
      first_name: user.firstName,
      last_name: user.lastName,
      password1: user.password,
      password2: user.confirmPassword,
      username: user.username,
      email: user.email,
      consent_form: true,
      profile:{school: user.school},
      survey_id: user.survey_id,
      response_id: user.response_id
    });
  }
}

export default new AuthService();
